import React from 'react';

interface BulkProposalActionsProps {
  // How many untouched proposals this bar acts on.
  count: number;
  onAcceptAll: () => void;
  onDiscardAll: () => void;
}

// A compact "act on the whole run at once" bar shown above a block of
// consecutive untouched proposals, so a clinician faced with a long list from
// one agent turn doesn't have to confirm/discard each card individually.
const BulkProposalActions: React.FC<BulkProposalActionsProps> = ({ count, onAcceptAll, onDiscardAll }) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: 8,
      flexWrap: 'wrap',
      border: '1px solid var(--primary-subtle)',
      borderRadius: 10,
      background: 'var(--primary-subtle)',
      padding: '8px 10px',
      marginTop: 8,
    }}
  >
    <span style={{ fontSize: 12, color: 'var(--primary)', fontWeight: 600, flex: 1 }}>
      {count} propuestas sin revisar
    </span>
    <button
      onClick={onAcceptAll}
      style={{
        border: 'none',
        borderRadius: 8,
        padding: '5px 12px',
        background: 'var(--primary)',
        color: 'var(--card)',
        fontWeight: 600,
        fontSize: 12,
        cursor: 'pointer',
      }}
    >
      Aceptar todas
    </button>
    <button
      onClick={onDiscardAll}
      style={{
        border: '1px solid var(--border)',
        borderRadius: 8,
        padding: '5px 12px',
        background: 'var(--card)',
        color: 'var(--muted-foreground)',
        fontWeight: 600,
        fontSize: 12,
        cursor: 'pointer',
      }}
    >
      Descartar todas
    </button>
  </div>
);

export default BulkProposalActions;
